/// <reference path="../../global/fn.js" />

(function ($) {
  $.widget("nsp.infoPanel", {
    opts: {},

    _create: function () {
      this.wrap = this.element;

      $('[data-bs-toggle="tooltip"]', this.wrap).each(function () {
        var tooltipEl = document.getElementById($(this).attr("id"));
        var tooltip = new bootstrap.Tooltip(tooltipEl, {
          container: $(this).parent(),
        });

        tooltipEl.addEventListener("show.bs.tooltip", function () {
          // do something...
        });
      });

      this._addBodyClass();
      this._mobSlideToggle();

      $(window).resize(function () {
        if (api.vars.windW < api.vars.scr.desktop) {            
          // $(".b-info-panel__title", this.wrap).removeClass("open");
         
          // $(".b-info-panel__nav, .b-info-panel__cta, .b-info-panel__top p", this.wrap).hide();
        }  
        if (api.vars.windW > api.vars.scr.desktop) {
      
          $(
              ".b-info-panel__nav, .b-info-panel__cta, .b-info-panel__top p", this.wrap
            )
            .show();
        }
      });
    },

    _addBodyClass: function () {
      $("body").addClass("p-product");
    },

    _mobSlideToggle: function () {
      var title = this.wrap.find(".b-info-panel__title");
      var toggleElem = this.wrap.find(
        ".b-info-panel__nav, .b-info-panel__cta, .b-info-panel__top p"
      );

      title.click(function () {
        if (api.vars.windW < api.vars.scr.desktop) {
          $(this).toggleClass("open");
          toggleElem.slideToggle();
        }
      });
    },
  });
})(jQuery);
